"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const groupedSlotsShimmer = (rows) => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(styles_1.ContentHeader, null,
            react_1.default.createElement(styles_1.LoadingCell, null)),
        react_1.default.createElement(styles_1.ContentText, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.LoadingCell, null)),
            rows === 3 && (react_1.default.createElement("div", null,
                react_1.default.createElement(styles_1.LoadingCell, null))))));
};
function Loading() {
    return (react_1.default.createElement(styles_1.Container, null,
        groupedSlotsShimmer(3),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        groupedSlotsShimmer(2),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        groupedSlotsShimmer(3)));
}
exports.default = Loading;
//# sourceMappingURL=Loading.js.map